import { Col, Row, Container } from "react-bootstrap";
import ServicesTransportFilter from "../../../../components/filteration/ServiceTransport";
import ShopAdds from "../../../../components/shopAds/ShopAdds";
import Shops from "../../../../components/Multipleshopprofile/Components/Shops/Shops";
import { useEffect, useState, useContext } from "react";
import ShareModel from "../../../../components/Sharemodel";
import ShareOption from "../../../../components/Shareoption";
import BackArrow from "../../../../components/backArrow";
import { ShopContext } from "../../../../config/shopContext";
import { useLazyGetShopCategoriesQuery } from "../../../../features/shop/shopApiSlice";
import { useLazyGetFilteredServicesQuery } from "../../../../features/service/serviceApiSlice";
import "./serviceFilter.css";

const ServiceFilter = () => {
  const shopType = "serviceShop"; // unique context identifier
  const { getFilteredData, updateFilteredData } = useContext(ShopContext);
  const currentData = getFilteredData(shopType);

  const [isloading, setIsloading] = useState(false);
  const [shopdata, setShopdata] = useState(currentData.shopdata || []);
  const [showmodal, setShowmodal] = useState(false);
  const [showshare, setShowshare] = useState(false);

  const handleClosemodal = () => setShowmodal(false);
  const handleShow = () => setShowmodal(true);
  const handleCloseshare = () => { setShowshare(false); setShowmodal(true); };
  const handleShowshare = () => setShowshare(true);

  const [dataCategory, setDataCategory] = useState({ categoryid: "" });
  const [shopCategory, setShopCategory] = useState([]);
  const [shopCategorytwo, setShopCategorytwo] = useState([]);

  const [getShopCategories] = useLazyGetShopCategoriesQuery();
  const [getFilteredServices] = useLazyGetFilteredServicesQuery();

  const [filters, setFilters] = useState(currentData.additionalData || {
    businessType: "services",
    serviceid: "",
    profileName: "",
    categoryid: "",
    subCategoryid: "",
    country: "",
    state: "",
    city: "",
  });

  // Split only on the first "." so category names that contain dots stay intact.
  const parseIdName = (value = "") => {
    if (!value) return ["", ""];
    const idx = String(value).indexOf(".");
    if (idx === -1) return [value, value];
    return [value.slice(0, idx), value.slice(idx + 1)];
  };

  // Handle category selection
  const Handledata = (e) => {
    const { name, value } = e.target;
    if (!value || value === "Category" || value === "Select Category") {
      setDataCategory({ categoryid: "" });
      setFilters((prev) => ({
        ...prev,
        categoryid: "",
        subCategoryid: "",
      }));
      setShopCategorytwo([]);
      return;
    }

    const parsed = parseIdName(value);

    setDataCategory((prev) => {
      if (name === "categoryid") {
        return { ...prev, categoryid: parsed };
      }
      return { ...prev, [name]: parsed };
    });

    // Category change invalidates subcategory so options stay in sync.
    if (name === "categoryid") {
      setFilters((prev) => ({
        ...prev,
        categoryid: parsed[0] || "",
        subCategoryid: "",
      }));
      setShopCategorytwo([]);
    }
  };

  const categoryName = dataCategory?.categoryid?.[1];
  const categoryidone = dataCategory?.categoryid?.[0];

  useEffect(() => {
    setFilters(prev => ({ ...prev, categoryid: categoryidone || "" }));
  }, [categoryidone]);

  // Fetch main categories only. Sub-categories load when a category is selected.
  useEffect(() => {
    getShopCategories({ type: 'services', parentCategory: '' })
      .unwrap()
      .then(res => res?.success && setShopCategory(res.data?.Category || []))
      .catch(() => {});
  }, [getShopCategories]);

  // Fetch subcategories based on selected category
  const Mydata = () => {
    if (!categoryName) {
      setShopCategorytwo([]);
      return;
    }
    getShopCategories({ type: 'services', parentCategory: categoryName })
      .unwrap()
      .then(res => {
        if (res?.success) {
          setShopCategorytwo(res.data?.Category || []);
        } else {
          setShopCategorytwo([]);
        }
      })
      .catch(err => {
        console.log(err);
        setShopCategorytwo([]);
      });
  };

  // Prefetch sub-categories when category changes (not only on dropdown click).
  useEffect(() => {
    if (!categoryName) {
      setShopCategorytwo([]);
      return;
    }
    Mydata();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryName]);

  // Handle filter input changes
  const HandleFilters = (e) => {
    const { name, value } = e.target;
    // categoryid is managed by Handledata / sync effect as the raw id only
    if (name === "categoryid") return;
    const isPlaceholder = [
      "Category",
      "Select Sub Category",
      "Select country",
      "Select state",
      "Select city",
    ].includes(value);

    setFilters(prev => ({
      ...prev,
      [name]: isPlaceholder ? "" : value,
    }));
  };

  // Build query for filtering
  const buildQuery = () => {
    const query = {};
    const ignoredValues = [
      "",
      "category",
      "select category",
      "select sub category",
      "select country",
      "select state",
      "select city",
      "undefined",
      "null",
    ];

    Object.keys(filters).forEach(k => {
      const val = filters[k];
      if (typeof val === 'string') {
        const trimmed = val.trim();
        if (trimmed && !ignoredValues.includes(trimmed.toLowerCase())) {
          query[k] = trimmed;
        }
      }
    });

    if (categoryName && !ignoredValues.includes(categoryName.toLowerCase())) {
      query.category = categoryName;
    }

    return new URLSearchParams(query).toString();
  };

  const FilterHandler = () => {
    setIsloading(true);

    const query = buildQuery();
    getFilteredServices(query)
      .unwrap()
      .then(res => {
        setIsloading(false);
        const list = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res)
            ? res
            : res?.data?.Services || [];
        setShopdata(list);
        updateFilteredData(shopType, list, [], filters);
      })
      .catch((err) => {
        console.error("FilterHandler error:", err);
        setIsloading(false);
      });
  };

  // Initial load of services on mount
  useEffect(() => {
    FilterHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel showmodal={showmodal} handleClosemodal={handleClosemodal} handleShowshare={handleShowshare} />
      <Container>
        <BackArrow back="/BuyingSide" mystyle="service-filter-mobile-back d-lg-none" />
        <Row className="service-filter-row">
          <Col lg="4" className="screenHeight background-image">
            <div className="border b-radius height_100">
              <ServicesTransportFilter
                shopCategory={shopCategory}
                shopCategorytwo={shopCategorytwo}
                Handleadditioanalshop={HandleFilters}
                FilterHandler={FilterHandler}
                dataCategory={dataCategory}
                Handledata={Handledata}
                Mydata={Mydata}
                title="Search Services by Category & Location"
                category="Search by Category"
                search="Service Category"
                search2="Service Sub-Category"
                subcategory="Search by Sub-Category"
              />
            </div>
          </Col>

          <Col lg="8" className="screenHeight">
            <div className="border b-radius ps-3 pe-3">
              <BackArrow back="/BuyingSide" mystyle="pt-1 d-none d-lg-block" />
              <ShopAdds />
              <Shops
                isloading={isloading}
                link="/services-online"
                title="Service Profile"
                data={0}
                handleShow={handleShow}
                shopdata={shopdata}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ServiceFilter;
